<template>
    <div class="upload-widget-wrapper">
        <b-button v-if="showBackButton" class="back-button" type="is-light" icon-left="arrow-left" @click="goBack">
            Back
        </b-button>
        <b-upload v-show="!isUploading" v-model="selectedFile" :accept="accept" drag-drop @input="onFileChanged">
            <div class="upload-sloded-content">
                <slot></slot>
            </div>
        </b-upload>

        <div v-if="isUploading" class="upload-progress">
            <div class="upload-status-card">
                <div class="file-info" v-if="selectedFile">
                    <b-icon icon="file-upload" size="is-large"></b-icon>
                    <div class="file-details">
                        <h3 class="filename">{{ selectedFile.name }}</h3>
                        <p class="file-size">{{ humanFileSize(selectedFile.size) }}</p>
                    </div>
                </div>

                <div class="progress-section">
                    <div class="progress-info">
                        <span class="status" :class="{ 'is-success': uploadProgress === 100 }">
                            {{ uploadProgress === 100 ? 'Upload Complete!' : uploadStatusText }}
                        </span>
                        <span class="percentage">{{ uploadProgress }}%</span>
                    </div>
                    <b-progress :rounded="true" size="is-medium" :value="uploadProgress"
                        :type="uploadProgress === 100 ? 'is-success' : 'is-info'" show-value>
                    </b-progress>
                    <p class="upload-details" v-if="currentUploadStats">
                        {{ currentUploadStats }}
                    </p>
                </div>

                <div class="action-buttons" v-if="uploadProgress !== 100">
                    <b-button type="is-danger" outlined icon-left="close" @click="cancelUpload()">
                        Cancel Upload
                    </b-button>
                </div>

                <div class="completion-actions" v-else>
                    <div class="success-message">
                        <b-icon icon="check-circle" type="is-success" size="is-large"></b-icon>
                        <h3>Upload Successfully Completed!</h3>
                    </div>
                    <b-button v-if="showUploadOtherButton" type="is-success" icon-left="upload" @click="resetUpload()">
                        Upload Another File
                    </b-button>

                    <p class="processing-note">
                        You can safely close or submit this window. Your media will continue processing in the
                        background.
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as tus from 'tus-js-client';
import axios from "axios";
import moment from 'moment';
export default {
    name: "videoModal",
    props: {
        videoId: {
            type: String,
            default: null
        },
        canCreate: {
            type: Boolean,
            default: true
        },
        libraryId: {
            type: String,
            default: null
        },
        app: {
            type: String,
            default: "none.com"
        },
        streamServerBaseUrl: {
            type: String,
            default: "https://streaming-server-api.watch.rw"
        },
        accept: {
            type: String,
            default: ".mp4,.mkv,.mp3"
        },
        showUploadOtherButton: {
            type: Boolean,
            default: false
        },
        showBackButton: {
            type: Boolean,
            default: true
        }

    },
    data() {
        return {
            eventSource: null,
            selectedFile: null,
            isUploading: false,
            uploadProgress: 0,
            uploadCtx: null,
            isUploadPaused: false,
            uploadMediaId: null,
            canMediaCreated: true,
            currentUploadStats: null,
            uploadStatusText: 'Preparing upload...',
        }
    },
    mounted() {
        let vm = this;
        vm.uploadMediaId = vm.videoId;
        vm.canMediaCreated = vm.canCreate;
    },
    beforeDestroy() {
        if (this.eventSource) {
            this.eventSource.close();
        }
    },
    methods: {
        goBack() {
            this.$emit('back');
        },
        $moment: moment,
        getFileExtension(filename) {
            return filename.slice((filename.lastIndexOf(".") - 1 >>> 0) + 2);
        },
        onFileChanged(file) {
            let vm = this;
            if (!file) return;
            const ext = vm.getFileExtension(file.name);
            vm.startUpload(file, ext == 'mp3' ? 'audio' : 'video');
        },
        startUpload(file, fileType) {
            let vm = this;
            const payload = {
                canCreate: vm.canMediaCreated,
                videoId: vm.uploadMediaId,
                libraryId: vm.libraryId,
                app: vm.app,
                fileType: fileType,
            };
            axios({
                url: vm.streamServerBaseUrl + "/api/v1/videos/initiate-creation",
                method: "POST",
                data: payload
            }).then(response => {
                vm.$emit('created', {
                    videoId: response.data.videoId,
                    fileType: fileType,
                });
                vm.eventSource = new EventSource(`${vm.streamServerBaseUrl}/api/v1/videos/progress/${response.data.videoId}`);
                vm.eventSource.onmessage = (e) => {
                    let data = JSON.parse(e.data);
                    if (data) {
                        vm.$emit('progress',
                            {
                                type: data.status,
                                percentage: data.progress
                            }
                        );
                        if (data.status == 'cdn_upload_completed') {
                            vm.$emit('completed', {
                                type: 'cdn_upload',
                                data: data
                            });
                            vm.eventSource.close();
                            vm.eventSource = null;
                        }
                    }
                };

                vm.uploadMediaId = response.data.videoId;
                vm.canMediaCreated = false;

                vm.uploadCtx = new tus.Upload(file, {
                    endpoint: vm.streamServerBaseUrl + "/api/v1/videos/files",
                    retryDelays: [0, 3000, 5000, 10000, 20000, 60000, 60000],
                    headers: {
                        VideoId: response.data.videoId,
                    },
                    metadata: {
                        title: response.data.title,
                        videoId: response.data.videoId,
                        fileType: fileType,
                    },
                    onError: function (error) {
                        vm.$emit('error', error);
                    },
                    onProgress: function (bytesUploaded, bytesTotal) {
                        var percentage = (bytesUploaded / bytesTotal * 100).toFixed(2);
                        vm.uploadProgress = parseInt(percentage);
                        vm.currentUploadStats = `Uploaded ${vm.humanFileSize(bytesUploaded)} of ${vm.humanFileSize(bytesTotal)}`;
                        vm.uploadStatusText = 'Uploading...';

                        vm.$emit('progress', {
                            type: 'server_upload',
                            bytesUploaded: bytesUploaded,
                            bytesTotal: bytesTotal,
                            percentage: vm.uploadProgress,
                            label: `${vm.currentUploadStats} (${percentage}%)`
                        });
                    },
                    onSuccess: function () {
                        vm.selectedFile = null;
                        vm.uploadMediaId = null;
                        vm.canMediaCreated = true;
                        vm.$emit('completed', {
                            type: 'server_upload',
                        });
                    }
                });

                // Check if there are any previous uploads to continue.
                vm.uploadCtx.findPreviousUploads().then((previousUploads) => {
                    // Found previous uploads so we select the first one.
                    if (previousUploads.length > 0 && previousUploads[0].metadata.title == response.data.title) {
                        let creationTime = vm.$moment(previousUploads[0].creationTime).fromNow();
                        vm.$buefy.dialog.confirm({
                            title: 'Important Message',
                            message: `You already started uploading this file ${creationTime}. Do you want to resume this upload?`,
                            cancelText: 'NO, START OVER',
                            confirmText: 'YES, RESUME',
                            type: 'is-success',
                            canCancel: ['button'],
                            onConfirm: () => {
                                vm.uploadCtx.resumeFromPreviousUpload(previousUploads[0]);
                                vm.uploadCtx.start();
                                vm.$emit('started', {
                                    videoId: response.data.videoId,
                                    fileType: fileType,
                                    fileName: file.name,
                                });
                                vm.isUploading = true;
                            },
                            onCancel: () => {
                                vm.uploadCtx.start();
                                vm.$emit('started', {
                                    videoId: response.data.videoId,
                                    fileType: fileType,
                                    fileName: file.name,
                                });
                                vm.isUploading = true;
                            }
                        })
                    } else {
                        vm.uploadCtx.start();
                        vm.$emit('started', {
                            videoId: response.data.videoId,
                            fileType: fileType,
                            fileName: file.name,
                        });
                        vm.isUploading = true;
                    }
                });


            }).catch(error => {
                vm.$emit('error', error);
            })

        },
        humanFileSize(bytes, si = true, dp = 1) {
            const thresh = si ? 1000 : 1024;

            if (Math.abs(bytes) < thresh) {
                return bytes + ' B';
            }
            const units = si
                ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
                : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
            let u = -1;
            const r = 10 ** dp;

            do {
                bytes /= thresh;
                ++u;
            } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);
            return bytes.toFixed(dp) + ' ' + units[u];
        },
        cancelUpload() {
            let vm = this;
            const payload = {
                videoId: vm.uploadMediaId,
            };
            axios({
                url: vm.streamServerBaseUrl + "/api/v1/videos/delete-uploaded-media",
                method: "POST",
                data: payload
            }).then(response => {
                if (vm.eventSource) {
                    vm.eventSource.close();
                }
                vm.uploadCtx.abort();
                vm.uploadCtx = null;
                vm.isUploading = false;
                vm.selectedFile = null;
                vm.$emit('reset');
            }).catch(error => {
                vm.$emit('error', error);
            })
        },
        resetUpload() {
            this.selectedFile = null;
            this.isUploading = false;
            this.uploadProgress = 0;
            this.currentUploadStats = null;
            this.uploadStatusText = 'Preparing upload...';
            this.$emit('reset');
        }
    }
}
</script>
<style scoped lang="scss">
.upload-widget-wrapper {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    .back-button {
        position: absolute;
        top: 10px;
        left: 10px;
    }

    .upload-progress {
        width: 600px;
        padding: 1.5rem;
    }

    .upload-status-card {
        background: white;
        border-radius: 8px;

        .file-info {
            display: flex;
            align-items: center;
            margin-bottom: 1.5rem;

            .file-details {
                margin-left: 1rem;

                .filename {
                    font-size: 1.2rem;
                    font-weight: 600;
                    margin-bottom: 0.25rem;
                }

                .file-size {
                    color: #666;
                    font-size: 0.9rem;
                }
            }
        }

        .progress-section {
            margin-bottom: 1.5rem;

            .progress-info {
                display: flex;
                justify-content: space-between;
                margin-bottom: 0.5rem;

                .status {
                    font-weight: 500;

                    &.is-success {
                        color: #48c774;
                    }
                }

                .percentage {
                    font-weight: 600;
                }
            }

            .upload-details {
                margin-top: 0.5rem;
                font-size: 0.9rem;
                color: #666;
            }
        }

        .action-buttons,
        .completion-actions {
            display: flex;
            justify-content: center;
            margin-top: 1.5rem;
        }

        .completion-actions {
            flex-direction: column;
            align-items: center;

            .success-message {
                text-align: center;
                margin-bottom: 1rem;

                h3 {
                    margin-top: 0.5rem;
                    color: #48c774;
                    font-weight: 600;
                }
            }

            .processing-note {
                margin-top: 1rem;
                font-size: 0.85rem;
                text-align: center;
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 0.5rem;
                max-width: 95%;
                line-height: 1.4;
                color: #848484;
            }
        }
    }
}
</style>